import DatasetTable, { datasetTableColumns } from "@/components/DatasetTable/DatasetTable";
import PageButtonGroup from "@/components/PageButtonGroup/PageButtonGroup";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import PremiumExplore from "@/components/PremiumFeatureComponents/PremiumExplore";
import useTableStateUrl from "@/components/Table/hooks/useTableStateUrl";
import TableHeader from "@/components/TableHeader/TableHeader";
import useAnalytics from "@/hooks/useAnalytics";
import { useCompanyAccess } from "@/hooks/useCompanySettings";
import { useImpactDatasets } from "@/hooks/useEcoInventDatasets";
import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { extraColumn } from "./AllReferences";

export default function EpdReferences() {
  const analytics = useAnalytics();
  const navigate = useNavigate();
  const access = useCompanyAccess();
  const column = extraColumn(navigate);

  analytics.track("EPD References Overview Viewed");

  const columns = [
    ...datasetTableColumns.filter((x) => x.key !== "dataset_type"),
    ...(column ? [column] : []),
  ];

  const { pagination, filter, search, sort, onSearchFilterSortPaginate } = useTableStateUrl({
    columns,
    defaultPagination: { page: 1, pageSize: 20 },
  });

  const newSearch = { dataset_type: "epd", ...search };

  const { data, isLoading, isFetching } = useImpactDatasets({
    pagination,
    filter,
    search: newSearch,
    sort,
  });

  if (access && !access.includes("epd")) {
    return <PremiumExplore title={"EPD"} />;
  }

  return (
    <div>
      <PageHeader
        title="EPDs"
        description="Use Environmental Product Declaration (EPD) data to improve accuracy in product impact assessment."
      />
      <div>
        <TableHeader
          left={
            <PageButtonGroup>
              <Button onClick={() => navigate("/impact_references/epd/create")}>
                <PlusOutlined />
                Add EPD
              </Button>
            </PageButtonGroup>
          }
        />
        <DatasetTable
          columns={columns}
          totalRows={data?.total_count}
          onSearchFilterSortPaginate={onSearchFilterSortPaginate}
          pagination={pagination}
          data={data?.datasets}
          filter={filter}
          search={search}
          sort={sort}
          loading={isLoading || isFetching}
          rowLink={(record) => `/impact_references/epd/${record.id}`}
        />
      </div>
    </div>
  );
}
